export type { FieldInfo } from '../../services/result-fields.service';
export type { ResultFieldsResponse } from '../../services/result-fields.service';
export { ResultFieldsService } from '../../services/result-fields.service';
